import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCurrentWeek' && prop !== 'isSelected'
})<{ isCurrentWeek: boolean; isSelected: boolean }>`
  ${({ theme, isCurrentWeek, isSelected }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border-radius: 12px;
    border: ${isCurrentWeek ? '2px' : '1px'} solid ${isCurrentWeek ? theme.colors.primary : theme.colors.border.light};
    background: ${isSelected ? theme.colors.background.hover : theme.colors.lightest};
    box-shadow: 4px 4px 8px 0 ${theme.colors.background.hover};
    cursor: pointer;
  `}
`

export const WeekTitle = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`

export const Header = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const WeekLabel = styled(Box)`
  ${({ theme }) => css`
    font-size: 18px;
    font-weight: 700;
    color: ${theme.colors.primary};
  `}
`

export const CurrentWeekBadge = styled(Box)`
  ${({ theme }) => css`
    padding: 2px 6px;
    border-radius: 4px;
    color: ${theme.colors.lightest};
    background: ${theme.colors.primary};
    font-size: 11px;
    font-weight: 700;
    line-height: 1.4;
  `}
`

export const UnitsBadge = styled(Box)`
  ${({ theme }) => css`
    font-size: 12px;
    font-weight: 600;
    color: ${theme.colors.gray.dark};
    background: ${theme.colors.gray[100]};
    border-radius: 6px;
    padding: 4px 8px;
    white-space: nowrap;
  `}
`

export const StatusList = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const StatusRow = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const StatusLabel = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: ${theme.colors.secondary};
  `}
`

export const Dot = styled(Box)<{ color: string }>`
  ${({ color }) => css`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${color};
    flex-shrink: 0;
  `}
`

export const StatusIcon = styled(Box)`
  display: flex;
  align-items: center;
`

export const CountBadge = styled(Box)`
  font-size: 13px;
  font-weight: 700;
  border-radius: 6px;
  padding: 2px 8px;
  min-width: 24px;
  text-align: center;
`
